const mapkey = {
  atlasApiKey: 'GNGIaRMAjhJ6X0671IAQH8DKWMnR5KEZ',
};

export default mapkey;
